﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class KWRemark extends TKCustomElementFactory {
    form?: HTMLFormElement;
    dialog?: HTMLDialogElement;

    constructor() {
        super();
        this.form = this.querySelector('[data-tk-remark-form]') || undefined;
        this.dialog = this.closest('dialog') || undefined;
    }

    connectedCallback(): void {
        if (!this.form) return;

        this.registerListener();
    }

    registerListener() {
        const action = this.saveRemark.bind(this);

        this.pushListener({ event: 'submit', element: this.form!, action });
    }

    saveRemark(e: Event) {
        e.preventDefault();

        const saveURL = this.form!.action;
        const remark = this.form!.querySelector<HTMLTextAreaElement>('textarea[name="field-remark"]');
        if (!remark) return;

        const payload = {
            ['field-remark']: remark.value,
        };

        fetchRequest({
            requestURL: saveURL,
            payload,
            resolveHandler: this.resolveFunction.bind(this),
        });
    }

    resolveFunction(response: TKResponse<{ success: 'true' | 'false' }>) {
        if (response.dataAsJson.success === 'false') return;
        this.dialog?.close();
    }
}